// -*- mode: vue; js-indent-level: 2; -*-
<template lang="html">
  <div class="product-list">
    <beer-header title-img="/images/home/beers_text.png" nolink></beer-header>

    <b-overlay :show="is_loading">
      <b-row id="shop-title" align-h="center" class="shop-title-section">
        <b-col cols="12" md="8">
          <center><h2>En vente dans notre boutique au <router-link :to="{name: 'contact'}">94 rue d'Arras à Lille</router-link> actuellement</h2></center>
        </b-col>
      </b-row>

      <b-row align-h="center" class="beers-section">
        <b-col cols="12" md="8">
          <center><h2>Les biéres</h2></center>
          <b-row align-h="center" class="available-beers">
            <b-col>
              <b-row class="beer-list" align-v="top">
                <b-col align-v="bottom" sm="4" align="center" v-for="beer in orderBy(beers_in_production,'nom')" :key="beer.slug || beer.nom">
                  <beer-card :beer="beer"/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
    <monkey-footer/>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import BeerHeader from './Header'
import BeerCard from './BeerCard'
import MonkeyFooter from '../Footer'
import Vue2Filters from 'vue2-filters'

var data = {
  is_loading: false
}

export default {
  name: 'BeerList',

  computed: {
    ...mapState([
      'beers'
    ]),

    beers_in_production: function () {
      return this.beers
    }
  },

  components: {
    BeerHeader,
    BeerCard,
    MonkeyFooter
  },

  mixins: [Vue2Filters.mixin],

  data: function () {
    return data
  },
  mounted: function () {
    this.is_loading = true
    this.$store.dispatch('LOAD_BEER_LIST').then(() => {
      this.is_loading = false
      // Scroll vers l'ancre si présente dans l'URL
      this.$nextTick(() => {
        if (this.$route.hash === '#shop-title') {
          const element = document.getElementById('shop-title')
          if (element) {
            const menubarHeight = window.innerHeight * 0.08 // 8vh
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
            const offsetPosition = elementPosition - menubarHeight - 20 // 20px d'espace supplémentaire
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            })
          }
        }
      })
    }).catch(() => {
      this.is_loading = false
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.beer-list {
  margin-top: 20px;
  
  .col {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    
    @media (min-width: 576px) {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }
}

.product-list {
    background-color: #eee;
    overflow-x: hidden;
    width: 100%;
    max-width: 100%;
}

.shop-title-section {
    margin-top: 10px;
    margin-bottom: 20px;
}

.beers-section {
    margin-top: 10px;
}

.available-beers {
    background-color: white;
    margin-bottom: 20px;
    padding-bottom: 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    
    .beer-card {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .beer-label-round {
            @media (max-width: 575.98px) {
                width: 100% !important;
                max-width: 100% !important;
                min-width: 200px;
                clip-path: circle(40% at center);
            }
        }
    }
}

.available-beers {
    margin-bottom: 10vh;
}

.old-beers{
    background-color: #eee;
    margin-top: 10px;

    h2 {
        width: 100%;
        text-align: center;
        margin-bottom: 30px;
    }
}
</style>
